export const BASE_URL =
  process.env.NEXT_PUBLIC_API_URL ||
  (typeof window !== 'undefined' &&
  window.location.hostname.includes('evryhealth.com')
    ? 'https://api.evryhealth.com/api/v1'
    : 'https://apidev.evryhealth.com/api/v1/')
